import { toast } from "../components/hooks/use-toast";
export function handleFailure(error) {
    if (error.name === "AbortError") {
        return;
    }
    toast({
        title: "Fehler",
        description: (error === null || error === void 0 ? void 0 : error.message) ||
            "Die Abfrage konnte nicht ausgeführt werden. Bitte versuchen Sie es später nochmal.",
        variant: "destructive",
        // action: <ToastAction altText="Nochmal">Nochmal versuchen</ToastAction>,
    });
}
//# sourceMappingURL=error.js.map